// ─── Driver Endpoints ─────────────────────────────────────────────────────────

export const API_GET_DRIVER_URL = '/admin/driver/driversList/';
export const API_GET_DRIVER = '/admin/driver/getDriverById/';
export const API_ADD_DRIVER = '/admin/driver/addDriver/';
export const API_EDIT_DRIVER = '/admin/driver/updateDriver/';
export const API_DELETE_DRIVER = '/admin/driver/deleteDriver/';
export const API_DRIVER_PAYMENTS = '/admin/driver/getAllDriverTransactionsById/';
export const API_STATUS_CHANGE_RIDER = '/admin/driver/statusChange/';
export const API_BLOCK_RIDER = '/admin/driver/blockUnblock/';
export const API_DRIVER_EARNING = '/trip/driverTrips';
export const API_GET_DRIVER_STATS = '/driver/getAdminDriverStats';
export const API_GET_DRIVER_NEAR_BY = '/admin/getDriverNearBy/';
